import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEmail = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 14,
	viewBox: "0 0 18 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_206_101)",
		children: [/* @__PURE__ */ _jsx("rect", {
			y: .5,
			width: 18,
			height: 12.8571,
			rx: 2,
			fill: "url(#paint0_linear_206_101)",
			fillOpacity: .15
		}), /* @__PURE__ */ _jsx("path", {
			d: "M1.71429 0.5C0.771984 0.5 0 1.27198 0 2.21429V11.6429C0 12.5852 0.771984 13.3571 1.71429 13.3571H16.2857C17.228 13.3571 18 12.5852 18 11.6429V2.21429C18 1.27198 17.228 0.5 16.2857 0.5H1.71429ZM1.71429 1.35714H16.2857C16.3663 1.35714 16.44 1.37092 16.5134 1.39062L9.58929 8.375C9.25216 8.71567 8.73382 8.71565 8.39732 8.375L1.4933 1.38393C1.56424 1.36563 1.63667 1.35714 1.71429 1.35714ZM0.890625 2L5.9933 7.16293L0.897321 11.8906C0.874099 11.8116 0.857143 11.7306 0.857143 11.6429V2.21429C0.857143 2.13876 0.873257 2.06923 0.890625 2ZM17.1094 2C17.1267 2.06923 17.1429 2.13876 17.1429 2.21429V11.6429C17.1429 11.7306 17.1259 11.8116 17.1027 11.8906L12.0067 7.15625L17.1094 2ZM11.3973 7.76561L16.4732 12.4732C16.4123 12.4865 16.3513 12.5 16.2857 12.5H1.71429C1.6487 12.5 1.58773 12.4865 1.52679 12.4732L6.59598 7.77232L7.78795 8.97768C8.44964 9.64754 9.53669 9.64661 10.1987 8.97768L11.3973 7.76561Z",
			fill: "#959595"
		})]
	}), /* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsxs("linearGradient", {
		id: "paint0_linear_206_101",
		x1: 9,
		y1: .5,
		x2: 9,
		y2: 13.3571,
		gradientUnits: "userSpaceOnUse",
		children: [/* @__PURE__ */ _jsx("stop", { stopOpacity: 0 }), /* @__PURE__ */ _jsx("stop", { offset: 1 })]
	}), /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_206_101",
		children: /* @__PURE__ */ _jsx("rect", {
			y: .5,
			width: 18,
			height: 12.8571,
			rx: 2,
			fill: "white"
		})
	})] })]
});
export default SvgEmail;
